import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AppSettings } from '../../proyect.conf';
import { AutenticacionService } from './autenticacion.service';
import { GarantiaIdoneaModalidadHistorialCambio } from '../_models/garantia-idonea-modalidad-historial-cambio';

@Injectable({
  providedIn: 'root'
})
export class GarantiasIdoneasModalidadesHistorialesCambiosService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/garantiasIdoneasModalidadesHistorialesCambios';

  constructor(
    private httClient: HttpClient,
    private autServicio: AutenticacionService
  ) { }

  /**
   * Obtiene el listado completo de historiales de cambios.
   * GET /api/garantiasIdoneasModalidadesHistorialesCambios
   */
  listado() {
    return this.httClient.get(this.rutServicio).pipe(
      map(res => res as GarantiaIdoneaModalidadHistorialCambio[])
    );
  }

  /**
   * Obtiene el listado de historiales de cambios habilitados.
   * GET /api/garantiasIdoneasModalidadesHistorialesCambios/enabled
   */
  listadoHabilitados() {
    return this.httClient.get(this.rutServicio + '/enabled').pipe(
      map(res => res as GarantiaIdoneaModalidadHistorialCambio[])
    );
  }

  /**
   * Obtiene un registro de historial de cambio por su identificador único.
   * GET /api/garantiasIdoneasModalidadesHistorialesCambios/{id}
   */
  obtenerPorId(id: string) {
    return this.httClient.get(this.rutServicio + '/' + id).pipe(
      map(res => res as GarantiaIdoneaModalidadHistorialCambio)
    );
  }

  /**
   * Obtiene el listado de historiales habilitados para una modalidad de garantía específica.
   * GET /api/garantiasIdoneasModalidadesHistorialesCambios/garantiaIdoneaModalidad/{IdGarantiaIdoneaModalidad}/enabled
   */
  listadoHabilitadosPorGarantiaIdoneaModalidad(idGarantiaIdoneaModalidad: string) {
    return this.httClient.get(`${this.rutServicio}/garantiaIdoneaModalidad/${idGarantiaIdoneaModalidad}/enabled`).pipe(
      map(res => res as GarantiaIdoneaModalidadHistorialCambio[])
    );
  }

  /**
   * Crea un nuevo registro de historial de cambio.
   * POST /api/garantiasIdoneasModalidadesHistorialesCambios
   */
  crear(regCrear: GarantiaIdoneaModalidadHistorialCambio) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post(this.rutServicio, regCrear).pipe(
      map(res => res as GarantiaIdoneaModalidadHistorialCambio)
    );
  }

  /**
   * Actualiza un registro de historial de cambio existente.
   * PUT /api/garantiasIdoneasModalidadesHistorialesCambios
   */
  actualizar(regActualizar: GarantiaIdoneaModalidadHistorialCambio) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put(this.rutServicio, regActualizar).pipe(
      map(res => res as any)
    );
  }

  /**
   * Crea múltiples registros de historial de cambio de forma masiva.
   * POST /api/garantiasIdoneasModalidadesHistorialesCambios/bulk
   */
  crearMasivo(regsCrear: GarantiaIdoneaModalidadHistorialCambio[]) {
    const idUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    regsCrear.forEach(reg => reg.auditoriaUsuario = idUsuario);
    return this.httClient.post(this.rutServicio + '/bulk', regsCrear).pipe(
      map(res => res as any)
    );
  }
}
